// extracted by mini-css-extract-plugin
module.exports = {"lightConfirm":"LrvConfirm_lightConfirm__3tekl"};